"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ContentRegistry = _interopRequireDefault(require("./ContentRegistry"));
var _jsxRuntime = require("react/jsx-runtime");
const ContainerItem = ({
  contentElements
}) => {
  return contentElements.map(contentElement => contentElement && (0, _jsxRuntime.jsx)(_ContentRegistry.default, {
    contentElement: contentElement
  }, contentElement.id));
};
var _default = ContainerItem;
exports.default = _default;